import { IconTimes } from '@maia/icons';
import { MarkdownRenderer, TextButton } from '@maia/ui';
import { ReactNode } from 'react';
import {
  Dialog as AriaDialog,
  DialogTrigger as AriaDialogTrigger,
  Modal as AriaModal,
} from 'react-aria-components';

type ModalProps = {
  content: string | ReactNode;
  triggerSlot: ReactNode;
};

export function Modal(props: ModalProps) {
  const { content, triggerSlot } = props;

  return (
    <AriaDialogTrigger>
      {triggerSlot}
      <AriaModal className="fixed inset-0 grid place-content-center size-full bg-grayscale0/50 backdrop-blur-sm">
        <AriaDialog className="flex bg-grayscale0 size-fit p-32 shadow-1 max-w-[920px] max-h-[70vh] rounded-18">
          <div className="overflow-auto">
            {typeof content === 'string' ? (
              <MarkdownRenderer markdown={content} />
            ) : (
              <>{content}</>
            )}
          </div>
          <TextButton slot="close" className="ml-auto h-fit">
            <IconTimes className="size-24" />
          </TextButton>
        </AriaDialog>
      </AriaModal>
    </AriaDialogTrigger>
  );
}
